export const SET_ROLE = "SET_ROLE";
export const SET_NAVIGATION = "SET_NAVIGATION";
export const SET_ACTION_ITEM = "SET_ACTION_ITEM";
export const GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
export const SET_NOTIFICATION_COUNT = "SET_NOTIFICATION_COUNT";
export const SET_DEVICE = "SET_DEVICE";
export const GET_DASHBOARD_DETAILS = "GET_DASHBOARD_DETAILS";
export const SET_DASHBOARD_DETAILS = "SET_DASHBOARD_DETAILS";
export const RESET_DETAILS = "RESET_DETAILS";
export const SET_USER_ID = "SET_USER_ID";
export const SET_NOTIFICATION_MESSAGE = "SET_NOTIFICATION_MESSAGE";
export const BADGE_API = "BADGE_API";
export const SET_ACTIVE_BADGE_COUNT = "SET_ACTIVE_BADGE_COUNT";
export const SET_COMPLETED_BADGE_COUNT = "SET_COMPLETED_BADGE_COUNT";
export const SET_FISCAL_YEAR = "SET_FISCAL_YEAR";
export const SET_FISCAL_YEAR_DATE = "SET_FISCAL_YEAR_DATE";